async function loadResizeObserver(): Promise<void> {
  if (typeof globalThis.ResizeObserver !== "undefined") return;
  const { ResizeObserver } = await import("@juggle/resize-observer");
  globalThis.ResizeObserver =
    ResizeObserver as unknown as typeof globalThis.ResizeObserver;
}

export const ready = loadResizeObserver();
